export const TRACKER_TABS = {
  MILESTONES: "milestones",
  INVOICES: "invoices",
};

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

/** Debounce delay (ms) before firing an API-filtered fetch after a query change. */
export const FILTER_DEBOUNCE_MS = 300;

export const ALLOWED_INVOICE_UPLOAD_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const MILESTONE_STATUS_OPTIONS = [
  { value: "Not Submitted", label: "Not Submitted" },
  { value: "Submitted", label: "Submitted" },
  { value: "Paid", label: "Paid" },
];

export const INVOICE_STATUS_FORM_OPTIONS = [
  { value: "Invoiced", label: "Invoiced" },
  { value: "Pending Approval", label: "Pending Approval" },
  { value: "Rejected", label: "Rejected" },
];
